import useApi from './useApi';

const useCampService = () => {
  const {
    requestState,
    payload,
    error,
    api,
  } = useApi();

  const getCamp = (campId) => api({ method: 'get', url: `/camps/${campId}` });

  const getCampsByIds = async (campIds) => {
    if (
      !Array.isArray(campIds)
      || !campIds.every((element) => Number.isInteger(element))
    ) {
      return null;
    }
    try {
      const camps = await Promise.all(
        campIds.map(async (campId) => {
          const camp = (await getCamp(campId)).data;
          return camp;
        }),
      );
      return camps;
    } catch (e) {
      console.error('Error fetching camps:', e);
      return [];
    }
  };

  const getCampsMappedByIds = async (campIds) => {
    if (!Array.isArray(campIds)) {
      console.error('Input is not an array');
      return {};
    }
    const camps = await getCampsByIds(campIds);
    const campsMappedById = {};
    camps.forEach((camp) => {
      if (camp && camp.id) {
        campsMappedById[camp.id] = camp;
      }
    });
    return campsMappedById;
  };

  return [
    requestState,
    payload,
    error,
    {
      getCamp,
      getCampsByIds,
      getCampsMappedByIds,
    },
  ];
};

export default useCampService;
